import React from 'react';
import Navbar from 'components/navbar';
import { Outlet } from 'react-router-dom';

const FdpUpdatedScreenHoc = () => {
  return (
    <div>
      <Navbar heading="FDP Updated" searchComponent={<></>} progressComponent={<></>} />
      <Outlet />
    </div>
  );
};

export default FdpUpdatedScreenHoc;
